import * as THREE from 'three';
import { el, clear } from './dom.js';

/**
 * 視点作成モード（?edit=1）。
 * 物件ごとの viewpoints をスタッフが手で座標入力するのは非現実的なので、
 * 実際に歩いた位置をそのまま視点として記録し、JSON を書き出せるようにする。
 */
export function createAuthorPanel(container, { camera, property }) {
  /** 記録済みの視点。常に新しい配列に差し替える */
  let drafts = property.viewpoints.map((vp) => ({ ...vp }));
  /** 間取り図の印。ミニマップ側でクリックされるたびに差し替わる */
  let floorplan = null;

  const nameInput = el('input', {
    class: 'ai-input',
    type: 'text',
    placeholder: '部屋名（例: リビング）',
    maxlength: '40',
  });
  const list = el('ol', { class: 'author-list' });
  const output = el('textarea', { class: 'author-out', readonly: 'readonly', rows: '10' });

  const addBtn = el(
    'button',
    { class: 'btn', type: 'button', onClick: () => addCurrent() },
    '現在地を追加',
  );
  const copyBtn = el(
    'button',
    { class: 'btn', type: 'button', onClick: () => copyJson() },
    'JSONをコピー',
  );

  function addCurrent() {
    const name = nameInput.value.trim() || `視点${drafts.length + 1}`;
    const position = camera.position.toArray().map(round3);
    // 注視点はカメラの1m前方。実際に見ている向きがそのまま保存される
    const forward = camera.getWorldDirection(new THREE.Vector3());
    const lookAt = camera.position.clone().add(forward).toArray().map(round3);

    drafts = [...drafts, { name, position, lookAt }];
    nameInput.value = '';
    render();
  }

  function removeAt(index) {
    drafts = drafts.filter((_, i) => i !== index);
    render();
  }

  function render() {
    clear(list);
    drafts.forEach((vp, index) => {
      list.appendChild(
        el('li', {}, [
          el('span', {}, vp.name),
          el(
            'button',
            { class: 'author-del', type: 'button', onClick: () => removeAt(index) },
            '削除',
          ),
        ]),
      );
    });
    const record = {
      ...property,
      viewpoints: drafts.map((vp) => ({ name: vp.name, position: vp.position, lookAt: vp.lookAt })),
    };
    if (floorplan !== null) record.floorplan = floorplan;
    output.value = JSON.stringify(record, null, 2);
  }

  async function copyJson() {
    try {
      await navigator.clipboard.writeText(output.value);
      copyBtn.textContent = 'コピーしました';
    } catch {
      // クリップボードが使えない環境では手動選択に切り替える
      output.select();
      copyBtn.textContent = '選択しました（Ctrl+C）';
    }
    setTimeout(() => {
      copyBtn.textContent = 'JSONをコピー';
    }, 2000);
  }

  render();

  const root = el('aside', { class: 'author-panel' }, [
    el('header', { class: 'ai-head' }, '視点作成モード'),
    el('p', { class: 'author-hint' }, [
      '① 画面をドラッグ／WASDで見せたい位置まで移動し、部屋名を入れて「現在地を追加」。',
      el('br'),
      '② 右の間取り図をクリックすると、選択中の部屋の印がそこに置かれます。',
    ]),
    el('div', { class: 'author-row' }, [nameInput, addBtn]),
    list,
    output,
    copyBtn,
  ]);
  container.appendChild(root);

  return {
    get drafts() { return drafts; },
    /** 間取りミニマップ側で印が動いたら受け取って出力に反映する */
    setFloorplan(next) {
      floorplan = next;
      render();
    },
  };
}

function round3(n) {
  return Math.round(n * 1000) / 1000;
}
